import { ODSBreadcrumb, type ODSBreadcrumbMenuItemProps } from '@telekom-ods/react-ui-kit';
import React, { type MouseEvent } from 'react';

interface BreadCrumbProps {
  items: ODSBreadcrumbMenuItemProps[];
  onItemClicked?: (e: MouseEvent, clicked: { id: string }) => void;
}

export const BreadCrumb: React.FC<BreadCrumbProps> = ({ items, onItemClicked }) => (
  <ODSBreadcrumb
    items={items}
    {...(onItemClicked && {
      onClick: (e: React.MouseEvent) => {
        const target = e.currentTarget as HTMLElement;
        const id = target.getAttribute('data-id');
        if (id) {
          onItemClicked(e, { id });
        }
      },
    })}
  />
);

export default BreadCrumb;
